// export const baseURL = "http://localhot:4100/api/"; //Local
// export const baseURL = "https://cnp1837-api.developer24x7.com/";
export const baseURL = process.env.REACT_APP_API_BASE_URL; //development
export const imagePath = baseURL + "categoryImages/";
